var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRevolutBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 25,
  fill: "none",
  viewBox: "0 0 35 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#D9D9D8",
  d: "M30.9 1.059h-27a3.5 3.5 0 0 0-3.5 3.5v16.18a3.5 3.5 0 0 0 3.5 3.5h27a3.5 3.5 0 0 0 3.5-3.5V4.559a3.5 3.5 0 0 0-3.5-3.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M22.825 9.136a3.774 3.774 0 0 0-3.772-3.768H12.81v2.091h5.946c.941 0 1.721.74 1.738 1.648.009.455-.162.885-.481 1.21a1.67 1.67 0 0 1-1.199.504h-2.317a.15.15 0 0 0-.149.149v1.858q0 .049.028.087l3.931 5.453h2.877l-3.94-5.468c1.984-.099 3.581-1.766 3.581-3.764m-7.594-.56H12.81v9.792h2.421z"
})));
export default SvgRevolutBox;